module.exports = __webpack_public_path__ + "img/wagb-screen-3.3f3c03e4.webp";